module.exports = __webpack_public_path__ + "img/freespin.9e4a4cf1.png";